import Icon from '../components/Icon.vue'

Icon.register({"plug":{"width":1792,"height":1792,"paths":[{"d":"M1755 453q37 38 37 90.5t-37 90.5l-401 400 150 150-160 160q-163 163-389.5 186.5t-411.5-100.5l-362 362h-181v-181l362-362q-124-185-100.5-411.5t186.5-389.5l160-160 150 150 400-401q38-37 91-37t90 37 37 90.5-37 90.5l-400 401 234 234 401-400q38-37 91-37t90 37z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/plug.js
// module id = BZuW
// module chunks = 0